import React, { useEffect, useRef, useState } from "react";
import NavBar from "components/SideBar/SideBar2";
import { ToastContainer } from "react-toastify";
import { RingLoader } from "react-spinners";
import { Button } from "@material-ui/core";
import TableHeader from "../Utility/TableHeader";
import {
  getEntityList,
  profileInfo,
  setDefaultEntity,
  setIsChecked,
  setPeriodStore,
  setPeriodStoreSingle,
  storeSelectedGstinGSTR2A2BNEW,
} from "../action";
import { useDispatch, useSelector } from "react-redux";
import Gstr2a2bFilter from "../Utility/Filter";
import History from "./History";
import View from "./View";
import downloadWhite from "images/downloadWhite.svg";
import CustomSwitch from "../Utility/customSwitch";
import Slide from "@material-ui/core/Slide";
import filterImage from "../../../images/filterImg.png";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import HistoryFilter from "./HistoryFilter";
import { fetchStatus, headerColumns, reportType } from "./constants";
import ViewFilter from "../View/ViewFilter";
import { docStatus, docType, invoiceType } from "../View/constants";
import {
  areMonthsInTwoFinancialYears,
  dataTypesViewTab,
  extractMonthsInRange,
  extractMonthsInRangeMMYYYY,
  getLastDateOfMonth,
  recoStatus,
} from "../Utility/utility";
import { COMMON_MSGS } from "Constant/Messages";
import { errorToastMessage } from "utils/errorToast";
import {
  downloadFetchExcel,
  downloadHistoryExcel,
  downloadViewExcel,
  fetchGSTR2A2B,
  get2a2bChangedData,
  getHistoryData,
  getHistoryFilterList,
  getViewData,
  getViewFilterList,
  loader,
  setSelected,
  setSelectedUnique,
} from "./action";
import DownloadPopup from "./DownloadPopup";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});
const Gstr2A2BFetch = (props) => {
  const {
    startDate,
    endDate,
    entityMasterList,
    profileData,
    defaultEntity,
    selectedGstin,
    isChecked,
  } = useSelector((store) => store.gstr2a2bNewCommonReducer);

  const {
    loaderStatus,
    viewTableData,
    historyTableData,
    selected,
    selectUnique,
  } = useSelector((store) => store.gstr2a2bNewFetchReducer);

  const [open, setOpen] = useState(false);
  const interval = useRef("");
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("1");
  const [selectedFromDateRP, setSelectedFromDateRP] = useState(startDate);
  const [selectedToDateRP, setSelectedToDateRP] = useState(endDate);
  const [fetchStatusFilter, setFetchStatusFilter] = useState([]);
  const [reportTypeFilter, setReportTypeFilter] = useState([]);
  const [gstinTaxpayerFilter, setGstinTaxpayerFilter] = useState([]);
  const [taxpayerGstin, setTaxpayerGstin] = useState(null);
  const [ctinTaxpayerFilter, setCtinTaxpayerFilter] = useState([]);
  const [counterpartyGstin, setCounterpartyGstin] = useState(null);
  const [inumFilter, setInumFilter] = useState([]);
  const [inum, setInum] = useState(null);
  const [docTypeFilter, setDocTypeFilter] = useState([]);
  const [invoiceTypeFilter, setInvoiceTypeFilter] = useState([]);
  const [docStatusFilter, setDocStatusFilter] = useState([]);
  const [recoStatusFilter, setRecoStatusFilter] = useState([]);
  const [dataTypeFilter, setDataTypeFilter] = useState([]);
  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const [checkedItems, setCheckedItems] = useState({
    consolidated: true,
    monthwise: true,
  });
  const [dateRange, setDateRange] = useState([
    {
      startDate: startDate,
      endDate: endDate ? getLastDateOfMonth(endDate) : endDate,
      key: "selection",
    },
  ]);
  const [selectedYear, setSelectedYear] = useState("");
  const [taxpayerGstinList, setTaxpayerGstinList] = useState([]);
  const [viewTaxpayerGstinList, setViewTaxpayerGstinList] = useState([]);
  const [viewCtinList, setViewCtinList] = useState([]);
  const [viewInumList, setViewInumList] = useState([]);

  // pagination state
  const [pageNumberView, setPageNumberView] = useState(1);
  const [pageNumberHistory, setPageNumberHistory] = useState(1);
  const [pageLimitView, setPageLimitView] = useState(10);

  // search states
  const [searchHistory, setSearchHistory] = useState("");
  const [searchView, setSearchView] = useState("");
  const [downloadType, setDownloadType] = useState(null);

  const handleSelectedYear = (event) => {
    setSelectedYear(event.target.value);
  };
  useEffect(() => {
    dispatch(getEntityList());
  }, []);

  useEffect(() => {
    setSelectedFromDateRP(startDate);
    setSelectedToDateRP(endDate);
  }, [startDate, endDate]);

  async function handleTabChange(id) {
    await setActiveTab(id);
  }
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      // Prevent closing the dialog on backdrop click or Escape key press
      return;
    }
    setOpen(false);
  };

  async function handleClearFilter() {
    const return_period = extractMonthsInRange(startDate, endDate);
    if (!areMonthsInTwoFinancialYears(return_period)) {
      return errorToastMessage("Selection of maximum 2 FYs is allowed");
    }
    await dispatch(
      getViewData(
        selectedGstin,
        return_period,
        searchView,
        isChecked,
        false,
        1,
        10,
        "",
        dateRange,
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        []
      )
    );
    setSelectedFromDateRP(new Date(startDate));
    setSelectedToDateRP(new Date(endDate));
    setFetchStatusFilter([]);
    setReportTypeFilter([]);
    setGstinTaxpayerFilter([]);
    setCtinTaxpayerFilter([]);
    setInumFilter([]);
    setDocTypeFilter([]);
    setInvoiceTypeFilter([]);
    setDocStatusFilter([]);
    setRecoStatusFilter([]);
    setDataTypeFilter([]);

    handleClose();
  }

  // clear filter for history tab
  const clearFilterHistory = async () => {
    const return_period = extractMonthsInRange(startDate, endDate);
    // if (!areMonthsInTwoFinancialYears(return_period)) {
    //   return errorToastMessage("Selection of maximum 2 FYs is allowed");
    // }
    try {
      await dispatch(
        getHistoryData(
          1,
          selectedGstin,
          return_period,
          searchHistory,
          "",
          "",
          [],
          [],
          [],
          false
        )
      );
      setSelectedFromDateRP(new Date(startDate));
      setSelectedToDateRP(new Date(endDate));
      setFetchStatusFilter([]);
      setReportTypeFilter([]);
      setSelectedYear("");
      setGstinTaxpayerFilter([]);
      handleClose();
    } catch (error) {
      console.log("Error in clearFilterHistory::", error);
    }
  };

  // apply filter for history tab
  const applyFilterHistory = async () => {
    const return_period = extractMonthsInRange(startDate, endDate);
    const return_period_filter = extractMonthsInRange(
      selectedFromDateRP,
      selectedToDateRP
    );
    try {
      await dispatch(
        getHistoryData(
          1,
          selectedGstin,
          return_period,
          searchHistory,
          return_period_filter,
          selectedYear,
          gstinTaxpayerFilter,
          fetchStatusFilter,
          reportTypeFilter,
          false
        )
      );
      setOpen(false);
    } catch (error) {
      console.log("Error in applyFilterHistory::", error);
    }
  };

  async function handleFilterApply() {
    await handleSubmit();
    setOpen(false);
  }
  function handleReportTypeFilterChange(e) {
    setReportTypeFilter(e.target.value);
  }
  function handleFetchStatusFilterChange(e) {
    setFetchStatusFilter(e.target.value);
  }
  const defaultPropsTaxGstins = {
    options: activeTab === "1" ? taxpayerGstinList : viewTaxpayerGstinList,
    getOptionLabel: (option) => option,
  };
  function onChangeTaxpayerGstin(newValue) {
    setTaxpayerGstin(newValue);
  }
  function handleAddTaxpayerGstin() {
    if (taxpayerGstin != null) {
      let temp = [...gstinTaxpayerFilter, taxpayerGstin];
      temp = [...new Set([...temp])];
      setGstinTaxpayerFilter(temp);
      setTaxpayerGstin(null);
    }
  }
  function handleAddCounterpartyGstin() {
    if (counterpartyGstin != null) {
      let temp = [...ctinTaxpayerFilter, counterpartyGstin];
      temp = [...new Set([...temp])];
      setCtinTaxpayerFilter(temp);
      setCounterpartyGstin(null);
    }
  }
  const defaultPropsCounterPartyGstins = {
    options: viewCtinList,
    getOptionLabel: (option) => option,
  };
  function onChangeCounterpartyGstin(newValue) {
    setCounterpartyGstin(newValue);
  }
  function handleAddInum() {
    if (inum != null) {
      let temp = [...inumFilter, inum];
      temp = [...new Set([...temp])];
      setInumFilter(temp);
      setInum(null);
    }
  }
  const defaultPropsInum = {
    options: viewInumList,
    getOptionLabel: (option) => option,
  };
  function onChangeInum(newValue) {
    setInum(newValue);
  }
  function handleChipDelete(index, type) {
    let temp;
    if (type === "gstin") {
      temp = [...gstinTaxpayerFilter];
      temp.splice(index, 1);
      setGstinTaxpayerFilter(temp);
    } else if (type === "ctin") {
      temp = [...ctinTaxpayerFilter];
      temp.splice(index, 1);
      setCtinTaxpayerFilter(temp);
    } else if (type === "Inum") {
      temp = [...inumFilter];
      temp.splice(index, 1);
      setInumFilter(temp);
    } else console.log("error in filter");
  }
  function handleDocTypeFilterChange(e) {
    setDocTypeFilter(e.target.value);
  }
  function handleInvoiceTypeFilterChange(e) {
    setInvoiceTypeFilter(e.target.value);
  }
  function handleDocStatusFilterChange(e) {
    setDocStatusFilter(e.target.value);
  }
  function handleRecoStatusFilterChange(e) {
    setRecoStatusFilter(e.target.value);
  }
  function handleDataTypeFilterChange(e) {
    setDataTypeFilter(e.target.value);
  }
  const areMandatoryFieldsFilled = () => {
    return defaultEntity && selectedGstin?.length > 0 && startDate && endDate;
  };

  const handleSubmit = (
    search = "",
    msgFlag = true,
    isToast,
    pageNo,
    pageLimit
  ) => {
    console.log("handleSubmit search: ", search);

    if (!areMandatoryFieldsFilled()) {
      if (msgFlag === true) {
        errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      }
      return;
    }

    const return_period = extractMonthsInRange(startDate, endDate);
    const return_period_filter = extractMonthsInRange(
      selectedFromDateRP,
      selectedToDateRP
    );
    if (!areMonthsInTwoFinancialYears(return_period)) {
      return errorToastMessage("Selection of maximum 2 FYs is allowed");
    }
    dispatch(
      getViewData(
        selectedGstin,
        return_period,
        search,
        isChecked,
        isToast,
        pageNo,
        pageLimit,
        return_period_filter,
        dateRange,
        gstinTaxpayerFilter,
        ctinTaxpayerFilter,
        inumFilter,
        docTypeFilter,
        invoiceTypeFilter,
        docStatusFilter,
        recoStatusFilter,
        dataTypeFilter
      )
    );
  };
  const handle2a2bChange = (search = "", gstrType, isToast, msgFlag = true) => {
    if (!areMandatoryFieldsFilled()) {
      if (msgFlag === true) {
        errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      }
      return;
    }

    const return_period = extractMonthsInRange(startDate, endDate);
    if (!areMonthsInTwoFinancialYears(return_period)) {
      errorToastMessage("Selection of maximum 2 FYs is allowed");
      return;
    }

    dispatch(
      get2a2bChangedData(
        selectedGstin,
        return_period,
        search,
        gstrType,
        isToast
      )
    );
  };
  const handleCheckboxChange = (event) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  const handleDownload = async () => {
    if (!downloadType) {
      errorToastMessage("Please select atleast one option");
      return;
    }

    await dispatch(downloadFetchExcel(selected, downloadType));
    setOpenDownloadModal(false);
    setDownloadType(null);
    dispatch(setSelected([]));
    dispatch(setSelectedUnique([]));
  };

  const handleDownloadModal = () => {
    if (selectUnique?.length === 0) {
      return errorToastMessage("Please select atleast one record");
    }
    // if (!areMandatoryFieldsFilled()) {
    //   errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
    //   return;
    // }

    const return_period = extractMonthsInRange(startDate, endDate);
    // if (!areMonthsInTwoFinancialYears(return_period)) {
    //   errorToastMessage("Please select upto two Financial Years only");
    //   return;
    // }
    setOpenDownloadModal(true);
  };
  const handleFetch = async (flag) => {
    if (!areMandatoryFieldsFilled()) {
      errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      return;
    }

    const return_period = extractMonthsInRange(startDate, endDate);
    if (!areMonthsInTwoFinancialYears(return_period)) {
      errorToastMessage("Please select upto two Financial Years only");
      return;
    }
    if (interval.current) {
      clearInterval(interval.current);
    }
    await dispatch(fetchGSTR2A2B(selectedGstin, return_period, flag));
    getHistoryDataAfterFetching();
  };

  const handleSwitchChange = async (event) => {
    dispatch(loader(true));
    const gstrType = event.target.checked;
    dispatch(setIsChecked(gstrType));
    // await handle2a2bChange('', gstrType, true);
  };

  const handleOpen = async () => {
    if (!areMandatoryFieldsFilled()) {
      errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      return;
    }

    const return_period = extractMonthsInRange(startDate, endDate);
    if (!areMonthsInTwoFinancialYears(return_period)) {
      errorToastMessage("Selection of maximum 2 FYs is allowed");
      return;
    }
    if (activeTab === "1") {
      let response = await dispatch(
        getHistoryFilterList(selectedGstin, return_period)
      );
      setTaxpayerGstinList(response.gstinList);
      setOpen(true);
    } else {
      let response = await dispatch(
        getViewFilterList(selectedGstin, return_period, isChecked)
      );
      setViewInumList(response.invoiceList);
      setViewCtinList(response.cgstinList);
      setViewTaxpayerGstinList(response.gstinList);
      setOpen(true);
    }
  };

  // pagination functions
  const handlePageClick = (value) => {
    setPageNumberView(value.selected + 1);
    handleSubmit(searchView, false, false, value.selected + 1, pageLimitView);
  };
  // const handlePageClickHistory = async (value) => {
  //   if (interval?.current) {
  //     clearInterval(interval.current);
  //     console.log("interval cleared on handlePageClickHistory");
  //   }
  //   setPageNumberHistory(value.selected + 1);
  //   console.log(
  //     "handlePageClickHistory value.selected + 1:",
  //     value.selected + 1
  //   );
  //   handleSubmitHistory(false, searchHistory, value.selected + 1);
  // };
  
  const handlePageClickHistory = async (value) => {
    if (interval?.current) {
      clearInterval(interval.current);
      console.log("interval cleared on handlePageClickHistory");
    }
    setPageNumberHistory(value.selected + 1);
    console.log(
      "handlePageClickHistory value.selected + 1:",
      value.selected + 1
    );
    // handleSubmitHistory(false, searchHistory, value.selected + 1,false);
    dispatch(setSelected([]));
    dispatch(setSelectedUnique([]));
    if (interval.current) {
      clearInterval(interval.current);
    }
    console.log('calling getHistoryDataAfterFetching')
    let gstin = selectedGstin ?? []; 
    let period = (startDate && endDate) ? extractMonthsInRange(startDate, endDate) : [];
    console.log('gstin:', gstin, 'period:', period);
    getHistoryDataAfterFetching(searchHistory, value.selected + 1, gstin, period);
  };
  function onChangeRadio(e) {
    setDownloadType(e.target.value);
  }

  // handle Submit for History Tab
  // const handleSubmitHistory = (
  //   msgFlag = true,
  //   search = searchHistory,
  //   pageNo = pageNumberHistory
  // ) => {
  //   if (!areMandatoryFieldsFilled()) {
  //     if (msgFlag === true)
  //       errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
  //     return;
  //   }

  //   const return_period = extractMonthsInRange(startDate, endDate);

  //   if (!areMonthsInTwoFinancialYears(return_period)) {
  //     return errorToastMessage("Selection of maximum 2 FYs is allowed");
  //   }
  //   dispatch(setSelected([]));
  //   dispatch(setSelectedUnique([]));
  //   getHistoryDataAfterFetching(search, pageNo);
  // };

  const handleSubmitHistory = (
    msgFlag = true,
    search = searchHistory,
    pageNo = pageNumberHistory,
    passMandatory = true
  ) => {
    if(passMandatory){
if (!areMandatoryFieldsFilled()) {
      if (msgFlag === true)
        errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      return;
    }
    }
    

    const return_period = extractMonthsInRange(startDate, endDate);
 if(passMandatory){
    if (!areMonthsInTwoFinancialYears(return_period)) {
      return errorToastMessage("Selection of maximum 2 FYs is allowed");
    }}

    dispatch(setSelected([]));
    dispatch(setSelectedUnique([]));
    if (interval.current) {
      clearInterval(interval.current);
    }
    getHistoryDataAfterFetching(search, pageNo, selectedGstin, return_period);
  };

  // function for interval calling
  async function getHistoryDataAfterFetching(search, pageNo, gstins, periods) {
    // const return_period = extractMonthsInRange(startDate, endDate);
    const return_period_filter = extractMonthsInRange(
      selectedFromDateRP,
      selectedToDateRP
    );
    const ret_period = extractMonthsInRange(startDate, endDate);
    // Helper function to count in-process files
    const countInProcessFiles = (files) =>
      files.filter(
        (item) => !["COMPLETED", "FAILED"].includes(item?.STATUS?.toUpperCase())
      )?.length;

    // Initial data fetch
    console.log("545 selectedGstin:", gstins);
    console.log("545 ret_period:", periods);

    let fileDataTemp = await dispatch(
      getHistoryData(
        pageNo,
        gstins,
        periods,
        search,
        return_period_filter,
        selectedYear,
        gstinTaxpayerFilter,
        fetchStatusFilter,
        reportTypeFilter,
        false
      )
    );

    // Count in-process files
    let inProcessStatusCount = countInProcessFiles(fileDataTemp);

    if (fileDataTemp?.length > 0 && inProcessStatusCount > 0) {
      interval.current = setInterval(async () => {
        // Fetch updated data
        console.log("569 selectedGstin:", gstins);
        console.log("569 ret_period:", periods);
        fileDataTemp = await dispatch(
          getHistoryData(
            pageNo,
            gstins,
            periods,
            search,
            return_period_filter,
            selectedYear,
            gstinTaxpayerFilter,
            fetchStatusFilter,
            reportTypeFilter,
            false
          )
        );
        inProcessStatusCount = countInProcessFiles(fileDataTemp);

        // Clear interval if no files are in process
        if (inProcessStatusCount === 0) {
          clearInterval(interval.current);
          console.log("All files processed.");
        }
      }, 10000);
    }
  }

  // function for history download
  const handleHistoryDownload = () => {
    if (historyTableData?.length === 0) {
      return errorToastMessage("No Data available to download");
    }
    if (!areMandatoryFieldsFilled()) {
      return errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
    }
    const return_period = extractMonthsInRange(startDate, endDate);
    const return_period_filter = extractMonthsInRange(
      selectedFromDateRP,
      selectedToDateRP
    );
    dispatch(
      downloadHistoryExcel(
        selectedGstin,
        return_period,
        gstinTaxpayerFilter,
        return_period_filter,
        searchHistory,
        fetchStatusFilter,
        reportTypeFilter,
        selectedYear
      )
    );
  };

  // function for view download
  const handleDownloadView = () => {
    if (viewTableData?.length === 0) {
      return errorToastMessage("No Data available to download");
    }
    if (!areMandatoryFieldsFilled()) {
      return errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
    }
    const return_period = extractMonthsInRange(startDate, endDate);
    const return_period_filter = extractMonthsInRange(
      selectedFromDateRP,
      selectedToDateRP
    );
    dispatch(
      downloadViewExcel(
        selectedGstin,
        return_period,
        searchView,
        isChecked,
        return_period_filter,
        dateRange,
        gstinTaxpayerFilter,
        ctinTaxpayerFilter,
        inumFilter,
        docTypeFilter,
        invoiceTypeFilter,
        docStatusFilter,
        recoStatusFilter,
        dataTypeFilter
      )
    );
  };

  useEffect(() => {
    if (activeTab === "1") handleSubmitHistory(false);
    else if (activeTab === "2") {
      console.log("Interval cleared on tab change");
      clearInterval(interval.current);
    }
    return () => {
      console.log("Interval cleared useEffect on unmount");
      clearInterval(interval.current);
    };
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "2") handleSubmit("", false, true);
  }, [isChecked]);

  useEffect(() => {
    return () => {
      setPageNumberHistory(1);
      console.log("Selected filters cleared on component unmount");
      dispatch(setDefaultEntity(""));
      dispatch(storeSelectedGstinGSTR2A2BNEW([]));
      dispatch(profileInfo([]));
      dispatch(setPeriodStoreSingle(null));
      dispatch(setPeriodStore(null, null));
      console.log("Component unmount setPageNumberHistory 1");
    };
  }, []);

  // initial history fetch on render
  useEffect(() => {
    // dispatch(getHistoryData());
    getHistoryDataAfterFetching()
  }, []);

  return (
    <div>
      <NavBar
        currentPage={"GSTR-2A/2B  | Fetch"}
        module="gstr2a2bNew"
        history={props.history}
      >
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="sweet-loading">
          <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ width: "65%" }}>
            <Gstr2a2bFilter
              entityMasterList={entityMasterList}
              profileData={profileData}
            />
          </div>
          <div style={{ display: "flex", width: "35%" }}>
            <Button
              onClick={
                activeTab === "1"
                  ? () => handleSubmitHistory(true,'',1)
                  : () => handleSubmit()
              }
              variant="contained"
              color="primary"
              disabled={loaderStatus}
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                height: "30px",
                margin: "1.8em 5px 0px 0px",
                paddingLeft: "2em",
                paddingRight: "2em",
                textTransform: "capitalize",
              }}
            >
              Submit
            </Button>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <Button
            onClick={() => handleFetch("gstr2a")}
            type="submit"
            disabled={loaderStatus}
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              marginTop: "5px",
              height: "32px",
              fontSize: "12px",
              textTransform: "capitalize",
            }}
          >
            Fetch GSTR-2A
          </Button>
          <Button
            onClick={() => handleFetch("gstr2b")}
            type="submit"
            disabled={loaderStatus}
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              marginTop: "5px",
              marginLeft: "1.5em",
              height: "32px",
              fontSize: "12px",
              textTransform: "capitalize",
            }}
          >
            Fetch GSTR-2B
          </Button>
          {activeTab === "1" && (
            <Button
              onClick={handleDownloadModal}
              type="submit"
              disabled={loaderStatus}
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                marginTop: "5px",
                marginLeft: "1.5em",
                height: "32px",
                fontSize: "12px",
                textTransform: "capitalize",
              }}
            >
              <img
                src={downloadWhite}
                alt="Download"
                style={{
                  width: "30px",
                  height: "20px",
                  paddingBottom: "3px",
                }}
              />
              Download
            </Button>
          )}
        </div>
        <div></div>
        <div
          style={{
            marginTop: "1em",
            display: "flex",
            height: "3em",
            boxShadow: "0px 2px 3px 0px #8080805e",
            // paddingRight: "5px",
          }}
        >
          <TableHeader
            handleTabChange={handleTabChange}
            columns={headerColumns}
            activeTab={activeTab}
          />
          {activeTab === "2" && (
            <div style={{ marginRight: "1em" }}>
              <CustomSwitch handleSwitchChange={handleSwitchChange} />
            </div>
          )}
        </div>

        <div style={{ marginTop: "0.6em" }}>
          {activeTab === "1" && (
            <History
              handleOpen={handleOpen}
              handlePageClickHistory={handlePageClickHistory}
              setSearchHistory={setSearchHistory}
              handleSubmitHistory={handleSubmitHistory}
              handleHistoryDownload={handleHistoryDownload}
            />
          )}
          {activeTab === "2" && (
            <View
              handleOpen={handleOpen}
              handleSubmit={handleSubmit}
              handleDownloadView={handleDownloadView}
              handlePageClick={handlePageClick}
              setSearchView={setSearchView}
            />
          )}
        </div>
      </NavBar>
      <Dialog
        className="filterModal"
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth={true}
        maxWidth="sm"
      >
        <div
          style={{
            position: "absolute",
            top: "6px",
            left: "-26px",
            cursor: "pointer",
          }}
          onClick={activeTab === "1" ? clearFilterHistory : handleClearFilter}
        >
          <img src={filterImage} alt="filter" width="100px" height="40px" />
          <span
            style={{
              position: "absolute",
              top: "8px",
              left: "36px",
              fontSize: "12px",
              color: "white",
            }}
          >
            Filters
          </span>
        </div>
        <DialogTitle
          id="alert-dialog-slide-title"
          style={{ display: "flex", justifyContent: "end" }}
        >
          <Button
            onClick={activeTab === "1" ? clearFilterHistory : handleClearFilter}
            disabled={loaderStatus}
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              padding: "5px 45px",
              fontSize: "10px",
              marginRight: "10px",
            }}
          >
            Clear Filters
          </Button>
          <Button
            onClick={activeTab === "1" ? applyFilterHistory : handleFilterApply}
            disabled={loaderStatus}
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              padding: "5px 45px",
              fontSize: "10px",
            }}
          >
            Apply Filters
          </Button>
        </DialogTitle>

        <DialogContent style={{ padding: "0px 8px", marginBottom: "1em" }}>
          {activeTab === "1" && (
            <HistoryFilter
              // return period
              selectedToDateRP={selectedToDateRP}
              selectedFromDateRP={selectedFromDateRP}
              setSelectedToDateRP={setSelectedToDateRP}
              setSelectedFromDateRP={setSelectedFromDateRP}
              // fetch status filter
              fetchStatusList={fetchStatus}
              fetchStatusFilter={fetchStatusFilter}
              handleFetchStatusFilterChange={handleFetchStatusFilterChange}
              // report type filter
              reportTypeList={reportType}
              reportTypeFilter={reportTypeFilter}
              handleReportTypeFilterChange={handleReportTypeFilterChange}
              // gstin
              gstinTaxpayerFilter={gstinTaxpayerFilter}
              taxpayerGstin={taxpayerGstin}
              defaultPropsTaxGstins={defaultPropsTaxGstins}
              onChangeTaxpayerGstin={onChangeTaxpayerGstin}
              handleAddTaxpayerGstin={handleAddTaxpayerGstin}
              handleChipDelete={handleChipDelete}
              // FinancialYear
              selectedYear={selectedYear}
              handleSelectedYear={handleSelectedYear}
            />
          )}
          {activeTab === "2" && (
            <ViewFilter

              showDocInv = {false}
              // return period
              selectedToDateRP={selectedToDateRP}
              selectedFromDateRP={selectedFromDateRP}
              setSelectedToDateRP={setSelectedToDateRP}
              setSelectedFromDateRP={setSelectedFromDateRP}
              // invoice date
              initialStartDate={startDate}
              initialEndDate={endDate}
              minDate={startDate}
              maxDate={endDate}
              dateRange={dateRange}
              setDateRange={setDateRange}
              // gstin
              gstinTaxpayerFilter={gstinTaxpayerFilter}
              taxpayerGstin={taxpayerGstin}
              defaultPropsTaxGstins={defaultPropsTaxGstins}
              onChangeTaxpayerGstin={onChangeTaxpayerGstin}
              handleAddTaxpayerGstin={handleAddTaxpayerGstin}
              handleChipDelete={handleChipDelete}
              // ctin
              ctinTaxpayerFilter={ctinTaxpayerFilter}
              counterpartyGstin={counterpartyGstin}
              defaultPropsCounterPartyGstins={defaultPropsCounterPartyGstins}
              onChangeCounterpartyGstin={onChangeCounterpartyGstin}
              handleAddCounterpartyGstin={handleAddCounterpartyGstin}
              // inum
              inumFilter={inumFilter}
              inum={inum}
              defaultPropsInum={defaultPropsInum}
              onChangeInum={onChangeInum}
              handleAddInum={handleAddInum}
              // Doc type filter
              docTypeList={docType}
              docTypeFilter={docTypeFilter}
              handleDocTypeFilterChange={handleDocTypeFilterChange}
              // Invoice type filter
              invoiceTypeList={invoiceType}
              invoiceTypeFilter={invoiceTypeFilter}
              handleInvoiceTypeFilterChange={handleInvoiceTypeFilterChange}
              //  doc status
              docStatusList={docStatus}
              docStatusFilter={docStatusFilter}
              handleDocStatusFilterChange={handleDocStatusFilterChange}
              //  reco status
              recoStatusList={recoStatus}
              recoStatusFilter={recoStatusFilter}
              handleRecoStatusFilterChange={handleRecoStatusFilterChange}
              // Data type filter
              flag={"FetchViewTab"}
              dataTypeList={dataTypesViewTab}
              dataTypeFilter={dataTypeFilter}
              handleDataTypeFilterChange={handleDataTypeFilterChange}
            />
          )}
        </DialogContent>
      </Dialog>

      <DownloadPopup
        openDownloadModal={openDownloadModal}
        setOpenDownloadModal={setOpenDownloadModal}
        setDownloadType={setDownloadType}
        handleDownload={handleDownload}
        onChangeRadio={onChangeRadio}
      />
    </div>
  );
};

export default Gstr2A2BFetch;
